/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  message,
  Row,
  Col,
  Radio,
  DatePicker,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import "./../style/profile.css";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";

const MyAccount = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState([]);

  // Fetch profile on mount
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        "https://cafemandhurah.mandurahcafe.com.au/api/profile",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const user = res.data.user;

      form.setFieldsValue({
        first_name: user.first_name,
        middle_name: user.middle_name,
        last_name: user.last_name,
        email: user.email,
        mobile_no: user.mobile_no,
        address: user.address,
        city: user.city,
        zip_code: user.zip_code,
        gender: user.gender || "Male",
        dob: user.dob ? dayjs(user.dob) : null,
      });

      if (user.image) {
        setProfileImage([
          {
            uid: "-1",
            name: "profile.jpg",
            status: "done",
            url: user.image,
          },
        ]);
        form.setFieldsValue({
          image: [
            {
              uid: "-1",
              name: "profile.jpg",
              status: "done",
              url: user.image,
            },
          ],
        });
      }
    } catch (err) {
      message.error("Failed to fetch profile");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  // Handle form submission
  const onFinish = async (values) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (key === "dob" && values[key]) {
          formData.append(key, values[key].format("YYYY-MM-DD"));
        } else if (key !== "image") {
          formData.append(key, values[key]);
        }
      });

      // Append image
      if (values.image && values.image.length > 0) {
        const file = values.image[0];
        if (file.originFileObj) {
          formData.append("image", file.originFileObj);
        }
      }

      await axios.post(
        "https://cafemandhurah.mandurahcafe.com.au/api/profile/update",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      message.success("Profile updated successfully");
    } catch (err) {
      message.error("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SeoHelmet page="account" />
      <BreadcrumbBanner
        title="My Account"
        backgroundImage="/Images/banner-about.jpg"
      />
      <div className="profile-page">
        <h2 style={{ textAlign: "center", marginBottom: 24 }}>My Profile</h2>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ gender: "Male" }}
        >
          <Form.Item
            name="image"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            style={{ textAlign: "center", marginBottom: 24 }}
          >
            <Upload
              listType="picture-circle"
              maxCount={1}
              beforeUpload={() => false}
              fileList={profileImage}
              onChange={({ fileList }) => {
                setProfileImage(fileList);
                form.setFieldsValue({ image: fileList });
              }}
              accept="image/*"
            >
              {profileImage.length === 0 && "+ Upload"}
            </Upload>
          </Form.Item>

          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item
                name="first_name"
                label="First Name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item name="middle_name" label="Middle Name">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="last_name"
                label="Last Name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="email"
                label="Email Id"
                rules={[{ required: true, type: "email" }]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="mobile_no"
                label="Phone Number"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="gender"
                label="Gender"
                // rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Radio value="Male">Male</Radio>
                  <Radio value="Female">Female</Radio>
                  <Radio value="Other">Other</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="dob"
                label="Date of Birth"
                // rules={[{ required: true }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                name="address"
                label="Address Line 1"
                // rules={[{ required: true }]}
              >
                <Input.TextArea rows={2} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item name="city" label="City"
              //  rules={[{ required: true }]}
               >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="zip_code"
                label="Zip Code"
                // rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="orange-btn"
            >
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default MyAccount;
